import React from 'react'
import styled from 'styled-components'
import { MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import RoundedBox from '../RoundedBox'
import tokens from './assets/tokens.png'
import tokens2x from './assets/tokens@2x.png'
import Topic from '~shared/Topic'

const IconContainer = styled.div`
    position: relative;
    width: 118px;
    height: 118px;

    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
    }

    @media ${MqTablet} {
        width: 134px;
        height: 134px;
    }

    @media ${MqDesktop} {
        width: 186px;
        height: 186px;
    }
`

const Slide1 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>Mine DATA tokens</Topic.Title>
            <Topic.Paragraph>
                You can earn DATA by becoming an Operator and running Streamr nodes. By doing so,
                you help secure and scale the Network, and contribute your bandwidth and computing
                resources to the Network.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={tokens} srcSet={tokens2x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const Slide2 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>Mine DATA tokens</Topic.Title>
            <Topic.Paragraph>
                While the full token economics will only go live in the 1.0 milestone in late 2023,
                Streamr nodes can earn token rewards in the Brubeck milestone too.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={tokens} srcSet={tokens2x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const Slide3 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>Mine DATA tokens</Topic.Title>
            <Topic.Paragraph>
                The Streamr node runs well on commodity hardware, including ordinary computers,
                mini-computers such as Raspberry Pi—almost anything that can run Docker or node.js.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={tokens} srcSet={tokens2x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const Slide4 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>Mine DATA tokens</Topic.Title>
            <Topic.Paragraph>
                The node consumes bandwidth and CPU depending on your application workloads or
                mining settings, which determine how much data traffic flows through the node. For
                mining, high uptime and a stable connection will maximize rewards, and at least 8 GB
                of available RAM is recommended.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={tokens} srcSet={tokens2x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const MineDataTokens = () => <RoundedBox.Gallery items={[Slide1, Slide2, Slide3, Slide4]} />

export default MineDataTokens
